module.exports = __webpack_public_path__ + "static/media/time.32cc5b78.svg";